module.exports = __webpack_public_path__ + "img/dianchi-40.d471a08c.svg";